/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel, { ExitType } from 'cio/models/action';
import { isEmpty } from '@ember/utils';
import CampaignModel from 'cio/models/campaign';
import { PathType } from 'cio/utils/visual-workflow-builder/branch-paths';
import { CAMPAIGN_TYPES_WITH_EVENT_TIME_SUPPORT } from 'cio/utils/actions/wait-until';

interface CioActionWaitUntilInfoArgs {
  action: ActionModel;
  conditionsTagName?: string;
}

export default class CioActionWaitUntilInfo extends Component<CioActionWaitUntilInfoArgs> {
  PathType = PathType;

  get conditionsTagName() {
    return this.args.conditionsTagName ?? 'strong';
  }

  get isForever() {
    let { action } = this.args;

    let hasNoConditions = true;

    if (action.isPreBranchWaitUntil) {
      hasNoConditions = action.conditions.length === 0;
    } else {
      hasNoConditions = action.multiConditions.length === 0;
    }

    return hasNoConditions && action.exitType === ExitType.Never && isEmpty(action.delayEventAttr);
  }

  get hasEventTimeCondition() {
    return !isEmpty(this.args.action.delayEventAttr);
  }

  get showEventTimeCondition() {
    if (!this.hasEventTimeCondition) {
      return false;
    }

    let campaign = this.args.action.belongsTo('campaign').value() as CampaignModel | null;

    if (campaign == null) {
      return false;
    }

    return CAMPAIGN_TYPES_WITH_EVENT_TIME_SUPPORT.has(campaign.type);
  }

  get hasMaximumWait() {
    return this.args.action.exitType !== ExitType.Never;
  }
}
